gsap.registerPlugin(ScrollTrigger);

function initFadeIn() {

  const elements = document.querySelectorAll('.fade-in');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            autoAlpha: 0,
            yPercent: 5,
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }
}

function initFadeOut() {

  const elements = document.querySelectorAll('#main-content section');

  if (elements) {
    elements.forEach((el) => {
        gsap.to(el, {
            autoAlpha: 0,
            scrollTrigger: {
                trigger: el,
                start: 'bottom 25%',
                // end: 'top center',
                toggleActions: 'play none none reverse',
                scrub: true,
                invalidateOnRefresh: true,
                // markers: true
            }
        })
    })
  }
}

function initSwirlSpin() {

  const elements = document.querySelectorAll('.swirl');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            rotation:"90_short",
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                toggleActions: 'play none none reverse',
                scrub: true,
                // markers: true
            }
        })
    })
  }
}

function initContentBlocks() {

  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function() {

      const elements = gsap.utils.toArray('.blocks-wrapper .img-wrapper');

      if (elements.length > 1) {
        elements.forEach(function(el, i) {

          // gsap.from(el, {
          //   // autoAlpha: 0,
          //   scrollTrigger: {
          //       trigger: el,
          //       start: 'center center-=100px',
          //       endTrigger: ".blocks-wrapper",
          //       end: "bottom center+=277px",

          //       scrub: true,
          //       pin: el,
          //       pinSpacing: false,
          //       toggleActions: 'play restart none restart',
          //       // markers: true
          //   }
          // })

          if (i != 0) {
            gsap.set(el, {autoAlpha:0});
            gsap.to(el, {
              autoAlpha: 1,
              scrollTrigger: {
                  trigger: el,
                  start: 'top center+=277px',
                  // scrub: true,
                  toggleActions: 'play none none reverse',
                  // markers: true
              }
            })
          }

        });
      }

      const textCol = gsap.utils.toArray('.blocks-wrapper .content-col');

      if (textCol.length > 1) {
        textCol.forEach(function(el, i) {

          gsap.to(el, {
            autoAlpha: 0,
            scrollTrigger: {
                trigger: el,
                start: 'bottom 35%',
                end: "bottom 182px",

                scrub: true,
                toggleActions: 'play none none reverse',
                // markers: true
            }
          })

        });
      }

    }
  });
}

function initBorderDraw() {

  const elements = document.querySelectorAll('.borderDraw');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            width: "0%",
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                scrub: true,
                once: true,
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }
}

function initGrowingArrow() {

  const elements = document.querySelectorAll('.growing-arrow img');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            x: "-95%",
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                scrub: true,
                once: true,
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }
}

function initScrollBackground() {

  const bgWrap = document.querySelector('.bg-wrap');

  if (bgWrap) {

    const bgTimeline = gsap.timeline({

      scrollTrigger: {
        trigger: ".bg-wrap",
        start: "top top",
        // end: "+=200%",
        scrub: true,
        pin: true,
        // snap: {
        //   snapTo: 1 / (sections.length - 1), // snap to the closest .bg in the timeline
        //   duration: {min: 0.2, max: 0.5}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
        //   delay: 0.1, // wait 0.2 seconds from the last scroll event before doing the snapping
        //   ease: "none" // the ease of the snap animation ("power3" by default)
        // }
      }
    });

    let sections = gsap.utils.toArray(".bg");

    sections.forEach((el, i) => {

      if (sections[ i + 1 ]) {
        bgTimeline
          .to(el, {autoAlpha: 0})
          .to(sections[ i + 1 ], {autoAlpha: 1}, '<')
          .to(el.querySelector('.inner-banner'), {autoAlpha: 0, yPercent: -10}, '<')
          .from(sections[ i + 1 ].querySelector('.inner-banner'), {autoAlpha: 0, yPercent: 5}, '<')
      }
    });

  }
}

function initBlogSharePin() {
  if (document.querySelector('article .post-social-wrapper')) {
    ScrollTrigger.matchMedia({

      "(min-width: 421px)": function() {

        ScrollTrigger.create({
          trigger: 'article .post-social-wrapper',
          start: 'top 182px',
          endTrigger: '.inner-article',
          end: 'bottom 350px',
          pin: true,
          // markers: true,
        })
      }
    });
  }
}

function init(){
  // gsap.globalTimeline.getChildren().forEach(t => t.kill()),

  initContentBlocks() // with Pin
  initScrollBackground() // with Pin
  initBlogSharePin() // with Pin
  initBorderDraw()
  initGrowingArrow()
  initFadeIn()
  // initFadeOut()
  initSwirlSpin()
}

document.addEventListener('DOMContentLoaded', function(){
  init();
});

// // create an Observer instance
// const resizeObserver = new ResizeObserver(entries =>
//   // console.log('Body height changed:', entries[0].target.clientHeight)
//   init()
// )

// // start observing a DOM node
// resizeObserver.observe(document.body)
